import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import {
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
} from '@material-ui/core';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import DvrIcon from '@material-ui/icons/Dvr';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
// import CategoryIcon from '@material-ui/icons/CategoryOutlined';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
import QuestionAnswerOutlinedIcon from '@material-ui/icons/QuestionAnswerOutlined';

import { useStylesNavbar } from '../../../../hooks/admin/navbar/useStyle';
import { useSelectBoard } from '../../../../hooks/admin/navbar/useBoard';

import { useLazyQuery } from '@apollo/react-hooks';
import LIST_QUERY from '../../../../hooks/admin/navbar/useBoardCategoryList';

const Navbar = () => {
  const classes = useStylesNavbar();
  const selectBoard = useSelectBoard();

  const [boardList, setBoardList] = useState<Array<any>>([]);
  const [faqList, setFaqList] = useState<Array<any>>([]);
  const [inquiryList, setInquieryList] = useState<Array<any>>([]);
  const [newInquiry, setNewInquiry] = useState<any>({});

  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState(false);
  const [postOpen, setPostOpen] = useState(false);

  const [getCategoryList] = useLazyQuery(LIST_QUERY, {
    fetchPolicy: 'no-cache',
    onCompleted: (result) => {
      setBoardList([...result.board]);
      setFaqList([...result.FAQCategory]);
      setInquieryList([...result.inquiryCategory]);
      setNewInquiry({
        ...result.inquiries.items.reduce((data: any, item: any) => {
          data[item.categoryId] = ++data[item.categoryId] || 1;
          return data;
        }, {}),
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const onInquiryClick = () => {
    getCategoryList();
    setInquiryOpen(!inquiryOpen);
  };

  const onFaqClick = () => {
    getCategoryList();
    setFaqOpen(!faqOpen);
  };

  const onPostClick = () => {
    getCategoryList();
    setPostOpen(!postOpen);
  };

  const onSelectBoard = (id: number, name: string) => {
    selectBoard(id, name);
  };

  useEffect(() => {
    getCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ListItem button onClick={onInquiryClick}>
        <ListItemIcon>
          <ContactSupportOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          primary="1:1문의 관리"
          secondary={
            Object.keys(newInquiry).length !== 0 && (
              <Typography
                style={{ color: '#FF9E36', fontWeight: 'bold' }}
                variant="body2"
              >
                New!
              </Typography>
            )
          }
        />
        {inquiryOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={inquiryOpen} timeout="auto" unmountOnExit>
        <Link to="/admin/inquiry/unanswered" className={classes.linkText}>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <ArrowRightIcon />
            </ListItemIcon>
            <ListItemText
              primary="미답변"
              secondary={
                Object.keys(newInquiry).length !== 0 && (
                  <Typography
                    style={{ color: '#FF9E36', fontWeight: 'bold' }}
                    variant="body2"
                  >
                    {
                      Object.values(newInquiry).reduce(
                        (value: any, item: any) => (value += item),
                      ) as number
                    }
                  </Typography>
                )
              }
            />
          </ListItem>
        </Link>
        <Link to="/admin/inquiry/all" className={classes.linkText}>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <ArrowRightIcon />
            </ListItemIcon>
            <ListItemText primary="전체 문의" />
          </ListItem>
        </Link>
        {inquiryList.map((item: any) => (
          <Link
            onClick={() => onSelectBoard(item.id, item.name)}
            key={item.id}
            to={`/admin/inquiry/${item.id}`}
            className={classes.linkText}
          >
            <ListItem button className={classes.nested}>
              <ListItemIcon>
                <ArrowRightIcon />
              </ListItemIcon>
              <ListItemText
                primary={`${item.name}`}
                secondary={
                  Object.keys(newInquiry).indexOf(String(item.id)) >= 0 && (
                    <Typography
                      style={{ color: '#FF9E36', fontWeight: 'bold' }}
                      variant="body2"
                    >
                      {newInquiry[Number(item.id)]}
                    </Typography>
                  )
                }
              />
            </ListItem>
          </Link>
        ))}
        <Link to="/admin/inquiry/form" className={classes.linkText}>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <ArrowRightIcon />
            </ListItemIcon>
            <ListItemText primary="자동완성 관리" />
          </ListItem>
        </Link>
        <Link to={`/admin/inquiry/category`} className={classes.linkText}>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <ArrowRightIcon />
            </ListItemIcon>
            <ListItemText primary="1:1문의 카테고리" />
          </ListItem>
        </Link>
      </Collapse>

      <Divider />

      <ListItem button onClick={onFaqClick}>
        <ListItemIcon>
          <QuestionAnswerOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="FAQ 관리" />
        {faqOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={faqOpen} timeout="auto" unmountOnExit>
        {faqList.map((item: any) => (
          <Link
            onClick={() => onSelectBoard(item.id, item.name)}
            key={item.id}
            to={`/admin/faq/${item.id}`}
            className={classes.linkText}
          >
            <ListItem button className={classes.nested}>
              <ListItemIcon>
                <ArrowRightIcon />
              </ListItemIcon>
              <ListItemText primary={`${item.name}`} />
            </ListItem>
          </Link>
        ))}
        <Link to={`/admin/faq/category`} className={classes.linkText}>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <ArrowRightIcon />
            </ListItemIcon>
            <ListItemText primary="FAQ 카테고리" />
          </ListItem>
        </Link>
      </Collapse>

      <Divider />

      <ListItem button onClick={onPostClick}>
        <ListItemIcon>
          <DvrIcon />
        </ListItemIcon>
        <ListItemText primary="게시판 관리" />
        {postOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={postOpen} timeout="auto" unmountOnExit>
        {boardList.map((item: any) => (
          <Link
            onClick={() => onSelectBoard(item.id, item.name)}
            key={item.id}
            to={`/admin/post/${item.id}`}
            className={classes.linkText}
          >
            <ListItem button className={classes.nested}>
              <ListItemIcon>
                <ArrowRightIcon />
              </ListItemIcon>
              <ListItemText primary={`${item.name}`} />
            </ListItem>
          </Link>
        ))}
        <Link to={`/admin/post/category`} className={classes.linkText}>
          <ListItem button className={classes.nested}>
            <ListItemIcon>
              <ArrowRightIcon />
            </ListItemIcon>
            <ListItemText primary="게시판 카테고리" />
          </ListItem>
        </Link>
      </Collapse>

      <Divider />
    </>
  );
};

export default Navbar;
